export default __webpack_public_path__ + "static/media/man3.7a9d335e.jpg";